import React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store/index'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import './styles/main.css'
import GlobalStyles from './styles/globalStyles'

import Router from './routes'

function App() {
    return (
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                {/* <BrowserRouter basename="/homologacao"> */}
                <BrowserRouter basename="/producao">
                {/* <BrowserRouter basename="/"> */}
                    <Router />
                    <Toaster toastOptions={{ duration: 2000 }} />
                    <GlobalStyles />
                </BrowserRouter>
            </PersistGate>
        </Provider>
    )
}

export default App
